export default "__VITE_ASSET__3b0ccaf1__"